// Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext'; // Asegúrate de que la ruta sea correcta
import '../styles/login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false); // Estado para el loader
  const [error, setError] = useState(''); // Estado para el mensaje de error
  const navigate = useNavigate();
  const { login } = useAuth(); // Obtén la función login del contexto

  const handleLogin = async () => {
    setLoading(true); // Empieza a cargar
    setError(''); // Resetea el mensaje de error
    try {
      const response = await fetch(`${API_BASE}/token-auth/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const userRole = data.roles[0];
        const token = data.token;

        // Log the token and data
        console.log('Token:', token);
        console.log('Data:', data);
        console.log('User Role:', userRole); // Log the user role

        // Use the login function to update the context
        login(token, userRole);

        // Redirect based on the role
        switch (userRole) {
          case 'admin':
            navigate('/init');
            break;
          case 'picker':
          case 'frozen':
            navigate('/picking');
            break;
          case 'storage':
            navigate('/storage');
            break;
          case 'sales':
            navigate('/sales');
            break;
          case 'production':
          case 'production_closer':
            navigate('/production');
            break;
          case 'scanner':
            navigate('/init');
            break;
          case 'checker':
            navigate('/admin');
            break;
          default:
            console.log('Redirecting to /');
            navigate('/');
        }
      } else {
        setError('Credenciales inválidas'); // Si las credenciales son incorrectas
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Hubo un error en la conexión. Intenta nuevamente.');
    } finally {
      setLoading(false); // Detenemos el loader después de completar la solicitud
    }
  };

  return (
    <div className="login-page">
    <div className="login-container">
      <div className="login-logo">
        <img src="/loken_logo.svg" alt="Loken Logo" className="logo-image" />
      </div>
      <h2 className="login-title">Iniciar Sesión</h2>
      <form className="login-form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
        <input
          type="text"
          placeholder="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="button" onClick={handleLogin} disabled={loading}>
          {loading ? 'Cargando...' : 'Iniciar sesión'}
        </button>
      </form>
      {error && <p className="login-error-message">{error}</p>}
      {loading && <div className="login-loader"></div>}
    </div>
  </div>

  );

}

export default Login;
